<template>
  <section class="page-course-details">
    <app-loading :isFull="true" v-if="isLoading" />
    <app-course-details
      :item="courseDetail"
      :goals="goals"
      :message="message"
      :listCourse="listCourse"
      @startEnroll="startEnroll"
    />
  </section>
</template>

<script>
import appCourseDetails from "cp/course-details.vue";
export default {
  name: "page-course-details",
  components: {
    appCourseDetails
  },
  data() {
    return {
      isLoading: false
    };
  },
   metaInfo() {
    return {
      title: this.courseDetail.course_title,
      meta:[
            {vmid: 'description', name: 'description', content: this.courseDetail.course_description_lite }
      ]
    };
  },
  computed: {
    courseId() {
      return this.$route.params.id;
    },
    courseDetail() {
      return this.$store.state.courses.courseDetail;
    },
    goals() {
      return this.$store.state.courses.goals;
    },
    message() {
      return this.$store.state.courses.msgs;
    },
    listCourse() {
      return this.$store.state.courses.listCourse;
    },
    // this is for check for loade this page reactive page
    userLogin() {
      return this.isLogin;
    },
    validUrl() {
      if (
        this.courseDetail.course_title_en ==
          this.$route.params.course_title_encourses &&
        this.courseDetail.en_subcategory == this.$route.params.en_subcategory &&
        this.courseDetail.en_category == this.$route.params.en_category &&
        this.courseDetail.id == this.$route.params.id
      ) {
        return true;
      } else {
        // this.$router.push("/404");
        return false;
      }
    }
  },
  mounted() {
    // TODO this is check for loade this page reactive load compunnet and swite in router
    this.checkEnroll();
  },
  destroyed() {
    // this.$store.commit("courses/clear");
  },
  methods: {
    async checkEnroll() {
      this.isLoading = true;
      // this.getInfo()
      // console.log(this.isLogin)
      // if (!this.isLogin) {
      //   this.getInfo()
      //   return
      // }
      try {
        let { data } = await axios.post("/enroll/check", {
          course_id: this.courseId
        });
        if (data.state != 200) {
          this.getInfo();
          return;
        }
        if (!data.enroll) {
          this.getInfo();
          return;
        } else {
          this.$router.push(`${this.linkCourses}/list-content`);
        }
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    async getInfo() {
      await this.$store.dispatch("courses/getCourseDetail", {
        id: this.courseId
      });
      await this.$store.dispatch("courses/getCourseCounts", {
        id: this.courseId
      });
      this.$store.dispatch("courses/getGoals", { id: this.courseId });
      this.$store.dispatch("courses/getInst", { id: this.courseId });
      this.$store.dispatch("courses/courseMsg", { id: this.courseId });
      this.$store.dispatch("contentCourses/commentGet", {
        course_id: parseInt(this.courseId)
      });
      
      this.isLoading = false;
    },
    async startEnroll(item) {
      if (!this.isLogin) {
        this.$store.commit("auth/setRedirect", false);
        this.showModalLogin();
        return;
      }
      await this.$store.dispatch("courses/startEnroll", item);
      this.checkEnroll();
    }
  }
};
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses.vue